import React from 'react';
import { FROM, FROM_SAVED_QUERY } from '@/util/enums/EnumLayers';
import AjaxSpinner from '@/components/AjaxSpinner';
import Layer from '@/components/layers/Layer';
import TableRef from '@/util/TableRef';
import { useLoadColumns_LEGACY } from '@/features/query-builder/hooks/LEGACY';

type QueryStep = Layer;

export type StepContentProps = {
  editMode: boolean;
  step: QueryStep;
  stepIndex: number;
  aliases: Record<string, TableRef>;
  onUpdateStep: F<QueryStep>;
  onEditStep: F<unknown>;
};

export const StepContent: React.FC<StepContentProps> = ({
  editMode,
  step,
  aliases,
  onUpdateStep,
  onEditStep,
  stepIndex,
}) => {
  const { allColumns, columnsByLayerId } = useLoadColumns_LEGACY(false, {
    layerInEditModeId: step._id,
    stepInEditModeIndex: stepIndex,
    includeHidden: true,
  });

  const columns = columnsByLayerId[step._id] ?? allColumns;

  if (editMode && !columns && ![FROM, FROM_SAVED_QUERY].includes(step.type())) {
    return <StepContentLoading />;
  }

  return editMode
    ? (step as any).editMode(columns, aliases, onUpdateStep, step)
    : (step as any).readonlyMode(onEditStep, aliases);
};

const SPINNER_STYLE = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const StepContentLoading = () => (
  <div style={SPINNER_STYLE}>
    <AjaxSpinner small />
  </div>
);
